import React from 'react';
import { Section } from './Section';
const steps = [{
  title: 'Configuras el Búnker',
  desc: 'Eliminas la fricción física y digital siguiendo el protocolo del manual.'
}, {
  title: 'Identificas tu Pico',
  desc: 'Localizas tus 180 minutos de máxima claridad biológica.'
}, {
  title: 'Ejecutas el Asalto',
  desc: 'Aplicas la Secuencia Alpha/Beta para aniquilar tu meta número 1 antes de que el mundo se despierte.'
}];
export function HowItWorksSection() {
  return <Section className="bg-tactical-gray border-y border-tactical-border" data-id="element-69">
      <h2 className="text-3xl md:text-5xl font-bold text-white uppercase text-center mb-10" data-id="element-70">
        Cómo <span className="text-accent" data-id="element-71">funciona</span>
      </h2>

      <div className="max-w-4xl mx-auto space-y-8" data-id="element-72">
        {steps.map((step, idx) => <div key={idx} className="flex flex-col items-center text-center bg-tactical-dark p-6 md:p-8 border border-tactical-border" data-id="element-73">
            <div className="text-6xl font-oswald select-none mb-4 font-[700] text-[#CF7849]" data-id="element-74">
              0{idx + 1}
            </div>
            <h3 className="text-2xl font-oswald text-white uppercase mb-2" data-id="element-75">
              {step.title}
            </h3>
            <p className="text-zinc-400 text-lg" data-id="element-76">{step.desc}</p>
          </div>)}
      </div>
    </Section>;
}